export default __webpack_public_path__ + "static/media/hourglass.b9e0e824.svg";